module.exports = __webpack_public_path__ + "assets/images/novasport_4.3027bc89576c89ce9aea001a3c402be8.png";